import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DateTime } from 'luxon';
import { DateInput, toDateTime } from '@utils/date.utils';
import { ValidationErrors } from '../../models/validation-errors.model';

export interface CompareDatesValidatorOptions {
  // pass if date to compare is a static value
  compareToDate?: DateTime;

  // pass if date should be read from other control in a group
  compareToControlPath?: string[];
  errorMessagePath?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DateValidatorsService {
  notGreaterThan(options: CompareDatesValidatorOptions) {
    return (control: AbstractControl): ValidationErrors | null => {
      const dateToCompare: DateTime | string = options.compareToDate || control.root.get(options.compareToControlPath)?.value;

      if (!control.value || !dateToCompare) {
        return null;
      }

      const controlDay = toDateTime(control.value as DateInput)?.startOf('day');
      const compareToDay = DateTime.isDateTime(dateToCompare)
        ? dateToCompare.startOf('day')
        : DateTime.fromISO(dateToCompare).startOf('day');

      if (!controlDay || controlDay <= compareToDay) {
        return null;
      }

      return {
        dateValidatorsNotGreaterThan: {
          message: options.errorMessagePath || 'error.date_max'
        }
      };
    };
  }
}
